// extracted by mini-css-extract-plugin
module.exports = {"theme":"rgba(28,153,226,.7529411765)","black":"#333","red":"#ea625b","green":"#38ca73","bgGradient":"linear-gradient(90deg, #0af, #0085ff)"};